module.exports = __webpack_public_path__ + "static/media/om_faceshape_diamond_vector.0daa7ae7.svg";